export default __webpack_public_path__ + "static/media/transfer-spoa.af23329e.svg";